export const initialState = {
  frameTitle: 'Potential Planning Ideas for You',
  frameBackgroundImage: 'meeting.png',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_FRAME':
      return {
        ...state,
        frameTitle: action.frameTitle,
        frameBackgroundImage: action.frameBackgroundImage,
      };
    default:
      return state;
  }
}
